import React, {Fragment, useEffect, useState} from "react";
import {SideDrawerProperties} from "../SideDrawer";
import {useUserProvider} from "../../providers/UserProvider";
import {Box, Button, Divider, Drawer, Typography, useMediaQuery} from "@material-ui/core";
import CustomMessageSideDrawer from "../CustomMessageSideDrawer";
import { useIntl } from "react-intl";
import CloseIcon from "@material-ui/icons/Close";
import {useDrawerStyles} from "../../theme/useDrawerStyles";
import {useMfwThemeProvider} from "myfitworld-utils";
import ContactSupportForm from "./ContactSupportForm";
import SubtleInfoMessage from "../SubtleInfoMessage";
import messages from "./messages";
import generalMessages from "../../messages";
import InfoTutorialFormTable from "../tables/InfoTutorialFormTable";
import ButtonScheduleConsultation from "../buttons/ButtonScheduleConsultation";

const HelpSectionDrawer = ({ isOpen, onClose }: Props) => {
  const { user } = useUserProvider();
  const {formatMessage} = useIntl();
  const theme = useMfwThemeProvider();
  const { mfwMuiWebTheme } = theme;
  const isMobile = useMediaQuery(mfwMuiWebTheme.breakpoints.down('sm'));
  const classes = useDrawerStyles(mfwMuiWebTheme, isMobile);
  const drawerClasses = classes();
  const [isLoading, setLoading] = useState(false);

  const [showArchived, setShowArchived] = useState<boolean>(false);

  useEffect(() => {
    if (!user) return;
  }, [user]);

  return (
    <Fragment>
      <CustomMessageSideDrawer 
        isOpen={isOpen} 
        onClose={onClose} 
        showArchived={showArchived} 
        setShowArchived={setShowArchived}
      >
        <Drawer classes={{paper: drawerClasses.drawerPaper}} variant="persistent" anchor="right" open={isOpen}>
          <Box className={drawerClasses.drawerHeader}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<CloseIcon/>}
              onClick={_ => onClose()}
              disabled={isLoading}
            >
              {formatMessage(generalMessages.close)}
            </Button>
          </Box>
          
          <Box mb={2}>
            <Typography variant='h4' gutterBottom>{formatMessage(messages.help_section)}</Typography>
          </Box>

          {!theme.theme.isWhiteLabel &&
            <Box>
              <SubtleInfoMessage>
                {formatMessage(messages.when_switch_on)}
              </SubtleInfoMessage>

              <InfoTutorialFormTable user={user} onClose={onClose} setLoading={setLoading} isLoading={isLoading}/>

              <Box mt={2} mb={2}>
                <Divider variant="middle" />
              </Box>

              <Box>
                <Typography variant='h4' gutterBottom>{formatMessage(messages.schedule_consultations)}</Typography>
              </Box>

              <ButtonScheduleConsultation isLoading={isLoading}/>

              <Box mt={2}>
                <Divider variant="middle" />
              </Box>
            </Box>
          }

          <Box mt={2} mb={2}>
            <Typography variant='h4' gutterBottom> {formatMessage(messages.contact_support)}</Typography>
          </Box>

          <ContactSupportForm />
        </Drawer>
      </CustomMessageSideDrawer>
    </Fragment>
  );
};

export default HelpSectionDrawer;

interface Props extends SideDrawerProperties {}
